var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2108 28.4249C38.2108 34.1359 33.581 38.7656 27.87 38.7656C22.1591 38.7656 17.5293 34.1359 17.5293 28.4249M27.8343 38.7657V44.4701M22.8048 44.47H32.8634M21.3469 27.8756H25.4999M21.3469 24.7234H25.4999M21.3469 21.5711H25.4999M21.3469 18.4185H25.4999M30.2409 27.8756H34.3939M30.2409 24.7234H34.3939M30.2409 21.5711H34.3939M30.2409 18.4185H34.3939M27.8704 11.5293C31.4732 11.5293 34.3939 14.45 34.3939 18.0528V28.3592C34.3939 31.962 31.4732 34.8827 27.8704 34.8827C24.2676 34.8827 21.3469 31.962 21.3469 28.3592V18.0528C21.3469 14.45 24.2676 11.5293 27.8704 11.5293Z",
    stroke: "#878686",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakers);
export default __webpack_public_path__ + "static/media/speakers.668704901228c5869cf51f41fc6da3b0.svg";
export { ForwardRef as ReactComponent };